import {
  rtmpDestinationV2EntityRaw,
  RtmpDestinationV2EntityRaw
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseResponseDTO } from "@youm-front/common/domain";

export class RtmpDestinationCreateResponseDTO extends BaseResponseDTO<RtmpDestinationCreateResponseDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationCreateResponseDTO.validationSchema()
  );

  constructor(value: RtmpDestinationCreateResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationCreateResponseDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["destination"],
      properties: {
        destination: rtmpDestinationV2EntityRaw
      },
      additionalProperties: false
    };
  }
}

interface RtmpDestinationCreateResponseDTORaw {
  destination: RtmpDestinationV2EntityRaw;
}
